import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "@/analytics/analytics";
import { trackSessionStarted } from "@/analytics/analytics";
import { useBrandingContext } from "@/providers/BrandingProvider";

function getUserRole(pathname: string): "admin" | "customer" | "end_user" | "eval" {
  try {
    const stored = sessionStorage.getItem("recruit_ai_user_role");
    if (stored === "admin" || stored === "customer" || stored === "end_user" || stored === "eval")
      return stored;
  } catch {}
  if (pathname.startsWith("/recruit-admin")) return "admin";
  if (pathname.startsWith("/customer")) return "customer";
  return "end_user";
}

const AnalyticsIdentity = () => {
  const { branding } = useBrandingContext();
  const location = useLocation();
  const sessionFired = useRef(false);

  useEffect(() => {
    if (!sessionFired.current) {
      sessionFired.current = true;
      trackSessionStarted();
    }
  }, []);

  const userId = useMemo(() => {
    try {
      // During impersonation, use the admin's saved userId so analytics attributes
      // events to the admin, not the impersonated user
      const isImpersonated = sessionStorage.getItem("recruit_ai_is_impersonated") === "1";
      if (isImpersonated) {
        return sessionStorage.getItem("recruit_ai_admin_user_id") || null;
      }
      return (
        sessionStorage.getItem("recruit_ai_analytics_user_id") ||
        sessionStorage.getItem("recruit_ai_user_id") ||
        sessionStorage.getItem("recruit_ai_enduser_user_id") ||
        null
      );
    } catch {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  const userType = useMemo(() => getUserRole(location.pathname), [location.pathname]);

  useEffect(() => {
    analytics.identify({
      userId,
      // Treat branding.customerId as account/customer grouping
      accountId: branding?.customerId || null,
      customerId: branding?.customerId || null,
      userType,
    });
  }, [userId, branding?.customerId, userType]);

  return null;
};

export default AnalyticsIdentity;
